<template>
  <div class="event-handling-container">
    <!-- 标题区域 - 单独一行 -->
    <div class="event-title">
      {{ title }}
    </div>

    <!-- 内容区域 - options 和 event-list 并排 -->
    <div class="content-wrapper">
      <!-- 选项列表 -->
      <div class="options-list">
        <div
            v-for="(item, index) in options"
            :key="index"
            :class="['option-item', { 'active': activeIndex === index }]"
            @click="handleOptionClick(index,item.estateId,item.type)"
        >
          <span :class="item.colorClass"></span>
          <span class="option-text">{{ item.estateName }}</span>
          <i class="el-icon-arrow-right" v-if="activeIndex === index"></i>
        </div>
      </div>

      <!-- 事件列表组件 -->
      <div class="event-list-wrapper">
        <vueeventlist ref="vueeventlist"></vueeventlist>
      </div>
    </div>
  </div>
</template>


<script>
import vueeventlist from './vueeventlist'
import {Message} from "element-ui";
import {getAllEstate} from "@/api/estate";
import vuecommatrs from "@/views/event_intervention/vuecommatrs";
export default {
  data() {
    return {
      parentActiveIndex: 1,
      activeIndex: 0,
      options: [],
      title:'投诉建议',

    };
  },
  components: {
    vueeventlist
  },
  methods: {
    handleOptionClick(index,id,type) {
      this.activeIndex = index;
      this.$refs.vueeventlist.$emit('sync-option', index,this.parentActiveIndex,id,type);
    },
    // 查询物业
    queryEstate() {
      getAllEstate().then(res => {
        this.options = res.data;
        this.$refs.vueeventlist.$emit('sync-option', this.activeIndex,this.parentActiveIndex,this.options[this.activeIndex].estateId,'');
      })
    }
  },
  mounted() {
    this.queryEstate()
    // 监听父组件传递的事件
    this.$on('sync-option', (index) => {
      // console.log(index)
      this.parentActiveIndex=index
      this.activeIndex=0
      this.options=[]
      if(index==0){
        this.title='公共安全感知'
      }else if(index==1)  {
        this.queryEstate()
        this.title='投诉建议'
      }else if(index==2)  {
        this.title='事件处理'
        this.options=[]
        this.options=[
          { estateName: '介入处理', colorClass: 'orange-dot', type: 1 },
          { estateName: '督办事件', colorClass: 'blue-dot', type: 2 }
        ]
        this.$refs.vueeventlist.$emit('sync-option', this.activeIndex,index,'',this.options[this.activeIndex].type);
      }
    });
  },
};
</script>


<style scoped>
.event-handling-container {
  display: flex;
  flex-direction: column; /* 垂直排列：标题 + 内容 */
  width: 1550px;
  height: 880px;
  background-color: rgba(2, 92, 96, 0.2);
  border-radius: 4px;
  overflow: hidden;
}

/* 标题样式 - 渐变背景 */
.event-title {
  width: 400px;
  padding: 16px 20px;
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
  background-image: linear-gradient(135deg, #016565, #0a2442);
  clip-path: polygon(0 0, 70% 0%, 100% 100%, 0 100%);
  flex-shrink: 0; /* 防止被压缩 */
}

.content-wrapper {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.options-list {
  width: 240px;
  padding: 10px;
}

.event-list-wrapper {
  flex: 1;
  padding: 10px;
  overflow: hidden;
}

/* 选项项基础样式 */
.option-item {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  margin-bottom: 8px;
  color: #ffffff;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

/* 选中状态样式 */
.option-item.active {
  background-color: rgba(0, 153, 153, 0.2);
  border-color: #00cccc;
}

/* 圆点样式 */
.blue-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #00ccff;
  margin-right: 10px;
}

.orange-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ff9933;
  margin-right: 10px;
}

.option-text {
  flex: 1;
}

/* 箭头图标样式 */
.el-icon-arrow-right {
  color: #00cccc;
  font-size: 16px;
}
</style>
